import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import Button from '@stories/Components/Buttons/GeneralButton/Button';
import styled, { css } from 'styled-components';
import { ReactComponent as SvgTick } from '@img/icons/tick.svg';
import { ReactComponent as SvgClose } from '@img/icons/cross-icon.svg';
import srOnly from '@helpers/srOnly';
import { Device, from } from '@helpers/media';
const ItemList = styled.div `
  ${setCssVar('accentColor', brand.sage.sageDark)};
  ${setCssVar('bgColor', brand.sage.sageDark)};
  ${setCssVar('bgColorAlt', brand.sage.sageLight)};
  ${setCssVar('fgColor', brand.white)};

  display: flex;
  flex-direction: column;
  min-height: 100%;
`;
const Top = styled.div `
  border-bottom: 1px solid ${brand.sage.sageLight};
  padding: 24px 15px;
`;
const Title = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  ${fonts.matter.medium};
  font-size: 16px;
  line-height: 24px;
  padding: 0;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;

  > svg {
    display: block;
    height: 16px;
    margin-right: 12px;
    width: 16px;
  }
`;
const Arrow = styled.span `
  display: flex;
  color: ${brand.black};
  height: 16px;
  margin-left: auto;
  width: 16px;

  svg {
    min-width: 16px;
    min-height: 16px;
  }
`;
const Item = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  ${fonts.matter.medium};
  font-size: 14px;
  line-height: 30px;
  padding: 11px 15px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${brand.sage.sageLight};
  width: 100%;

  ${({ isActive }) => isActive &&
    css `
      ${Arrow} {
        transform: rotate(180deg);
      }
    `}
`;
const Close = styled(SvgClose) `
  height: 11px;
  width: 11px;
  margin-right: 5px;
`;
const Tick = styled(SvgTick) `
  position: absolute;
  left: 15px;
  top: 16px;
  color: ${brand.sage.sageLight};
  width: 18px;
  opacity: 0;
  z-index: 1;
`;
const Clear = styled.button `
  ${fonts.matter.regular};
  display: block;
  background: none;
  border: 0;
  color: ${brand.sage.sageLight};
  font-size: 14px;
  line-height: 17px;
  margin: 20px 0 0;
  padding: 0;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: left;
`;
const ApplyFilters = styled(Button) `
  background-color: ${brand.sage.sageDark};
  border-color: ${brand.sage.sageDark};

  &:hover {
    background-color: ${cssVar('bgColorAlt')};
    border-color: ${cssVar('bgColorAlt')};
  }
  span {
    color: ${brand.black};
  }
`;
const RemoveFilters = styled(Button) `
  margin-top: 15px;
  border-color: ${brand.black};

  span {
    color: ${brand.black};
  }

  &:hover {
    background-color: ${cssVar('bgColorAlt')};
    border-color: ${cssVar('bgColorAlt')};
  }

  .theme-rss & {
    border-color: ${brand.white};

    span {
      color: ${brand.white};
    }

    &:hover {
      border-color: ${cssVar('bgColorAlt')};

      span {
        color: ${brand.black};
      }
    }
  }
`;
const BtnHolder = styled.div ``;
const FilterBtns = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1 0 auto;
  padding: 30px;
`;
const CheckboxArea = styled.div `
  display: flex;
`;
const CheckboxAreaContainer = styled.div `
  position: relative;
  border-bottom: 1px solid ${brand.sage.sageLight};
`;
const CheckboxAreaLabel = styled.button `
  ${fonts.matter.medium};
  font-size: 14px;
  line-height: 42px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: left;
  border-radius: 4px 4px 0 0;
  color: ${brand.sage.sageLight};
  flex: 1 0 100%;
  border: 1px solid ${brand.sage.sageLight};
  padding: 4px 15px;
  background: transparent;
  min-width: 200px;
`;
const CheckboxAreaItems = styled.div `
  background-color: ${brand.white};
  min-width: 100%;
  display: none;

  ${({ active }) => active &&
    css `
      display: block;
    `}
`;
const CheckBoxContainer = styled.div `
  position: relative;
  display: block;
  width: auto;

  & + & {
    margin-top: 15px;
  }

  @media ${from(Device.Tablet)} {
    & + & {
      margin-top: 0;
      margin-left: 56px;
    }
  }
`;
const CheckboxItemContainer = styled.div ``;
const CheckboxItem = styled.label `
  position: relative;
  display: block;
  padding: 0;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${brand.grey.greyLight};
  }
`;
const CheckboxInput = styled.input `
  ${srOnly}
`;
const CheckboxText = styled.span `
  display: block;
  margin: 0;
  padding: 10px 15px;
  font-size: 16px;
  line-height: 26px;

  ${CheckboxInput}:checked + & {
    padding-left: 45px;
    background-color: ${brand.grey.greyLight};

    ${Tick} {
      opacity: 1;
    }
  }
`;
const MobileButton = styled(Button) `
  margin: 20px auto;
  width: fit-content;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
export default {
    ApplyFilters,
    Arrow,
    BtnHolder,
    CheckboxArea,
    CheckboxAreaContainer,
    CheckboxAreaItems,
    CheckboxAreaLabel,
    CheckBoxContainer,
    CheckboxInput,
    CheckboxItem,
    CheckboxItemContainer,
    CheckboxText,
    Clear,
    Close,
    FilterBtns,
    Item,
    ItemList,
    RemoveFilters,
    Tick,
    Title,
    Top,
    MobileButton,
};
